// Dependecies
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
// Images
import ilustracion1 from '../../../sass/images/slider/ilustracion1.svg';
import ilustracion2 from '../../../sass/images/slider/ilustracion2.svg';
import ilustracion3 from '../../../sass/images/slider/ilustracion3.svg';

export default function useSlider() {
  const [t] = useTranslation('alt', { useSuspense: false });
  const content = [
    {
      title: 'title_1',
      description: 'message_1',
      img: ilustracion1,
      callToAction: 'register',
      path: 'Register',
      alt: `${t('ilustration_slider1')}`,
    },
    {
      title: 'title_2',
      description: 'message_2',
      img: ilustracion2,
      callToAction: 'register',
      path: 'Register',
      alt: `${t('ilustration_slider2')}`,
    },
    {
      title: 'title_3',
      description: 'message_3',
      img: ilustracion3,
      callToAction: 'register',
      path: 'Register',
      alt: `${t('ilustration_slider3')}`,
    },
  ];

  const [contentSlider] = useState(content);

  return { contentSlider };
}
